import React, {Component} from 'react';
import ChartistGraph from 'react-chartist';
import {Grid, Row, Col, Table} from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';
import Moment from 'react-moment';

import {Card} from 'components/Card/Card.jsx';
import {StatsCard} from 'components/StatsCard/StatsCard.jsx';
import {
    responsiveSales,
} from 'variables/Variables.jsx';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optionsSales: {
                low: 0,
                high: 100,
                showArea: false,
                height: "245px",
                axisX: {
                    showGrid: false,
                },
                lineSmooth: true,
                showLine: true,
                showPoint: true,
                fullWidth: true,
                chartPadding: {
                    right: 50
                }
            },
        }
    }

    componentWillReceiveProps(nextProps) {
        this.normalizeChartProps(nextProps);
    }

    componentWillMount() {
        this.normalizeChartProps(this.props);
    }

    normalizeChartProps(nextProps) {
        let optionsSales = this.state.optionsSales,
            numDates = nextProps.dateChart.series[0].length;

        optionsSales.high = nextProps.dateChart.series[0][numDates - 1];

        // How many labels do we want? Probably 10.
        let modulo = Math.floor(numDates / 10);
        // console.log(modulo);

        optionsSales.axisX = {
            labelInterpolationFnc: function (value, index) {
                return index % modulo === 0 ? value : null;
            }
        };

        this.setState({
            optionsSales: optionsSales,
        });
    }

    createLegend(json) {
        var legend = [];
        for (var i = 0; i < json["names"].length; i++) {
            var type = "fa fa-circle text-" + json["types"][i];
            legend.push(
                <i className={type} key={i}/>
            );
            legend.push(" ");
            legend.push(
                json["names"][i]
            );
        }
        return legend;
    }

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col lg={4} sm={4}>
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"/>}
                                statsText='Revenue'
                                statsValue={
                                    (this.props.revenue === undefined || this.props.lateFees === undefined)
                                        ? ''
                                        : '$' + (this.props.revenue + this.props.lateFees)
                                }
                                statsIcon={
                                    (this.props.revenue === undefined || this.props.lateFees === undefined)
                                        ? (<i className='pe-7s-refresh-2' id='loading'/>)
                                        : (<i className="fa fa-calendar-o"/>)
                                }
                                statsIconText={
                                    (this.props.revenue === undefined || this.props.lateFees === undefined)
                                        ? 'calculating'
                                        : 'cumulative'
                                }
                            />
                            <StatsCard
                                bigIcon={<i className="pe-7s-wallet text-success"/>}
                                statsText="Late Fees"
                                statsValue={
                                    (this.props.lateFees === undefined)
                                        ? ''
                                        : '$' + this.props.lateFees
                                }
                                statsIcon={
                                    (this.props.lateFees === undefined)
                                        ? (<i className='pe-7s-refresh-2' id='loading'/>)
                                        : (<i className="fa fa-calendar-o"/>)
                                }
                                statsIconText={
                                    (this.props.lateFees === undefined)
                                        ? 'calculating'
                                        : 'cumulative'
                                }
                            />
                            <StatsCard
                                bigIcon={<i className="pe-7s-graph1 text-danger"/>}
                                statsText="Total Paid Submissions"
                                statsValue={
                                    (this.props.numPaidSubmissions === undefined)
                                        ? ''
                                        : this.props.numPaidSubmissions
                                }
                                statsIcon={
                                    (this.props.numPaidSubmissions === undefined)
                                        ? (<i className='pe-7s-refresh-2' id='loading'/>)
                                        : (<i className="fa fa-calendar-o"/>)
                                }
                                statsIconText={
                                    (this.props.numPaidSubmissions === undefined)
                                        ? 'calculating'
                                        : 'cumulative'
                                }
                            />
                        </Col>
                        <Col lg={4} sm={4}>
                            <Card
                                statsIcon="fa fa-clock-o"
                                title="Ad Size Statistics"
                                category="sales according to size"
                                stats="Up-to-date"
                                content={
                                    <div id="chartPreferences" className="ct-chart ct-perfect-fourth">
                                        <ChartistGraph data={this.props.histogram.dataPie} type="Pie"/>
                                    </div>
                                }
                                legend={
                                    <div className="legend">
                                        {this.createLegend(this.props.histogram.legendPie)}
                                    </div>
                                }
                            />
                        </Col>
                        <Col lg={4} sm={4}>
                            <Card
                                statsIcon={
                                    (this.props.school.sizes === undefined)
                                        ? 'pe-7s-refresh-2'
                                        : 'fa fa-clock-o'
                                }
                                title="Current Prices"
                                stats={
                                    (this.props.school.sizes === undefined)
                                        ? 'loading'
                                        : 'up-to-date'
                                }
                                content={
                                    <div>
                                        {this.props.school.sizes !== undefined
                                            ? (
                                                <Table striped>
                                                    <thead>
                                                    <tr>
                                                        {
                                                            ['Size', 'Photos', 'Words', 'Price']
                                                                .map((prop, key) => {
                                                                    return (
                                                                        <th key={key}>{prop}</th>
                                                                    );
                                                                })
                                                        }
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.school.sizes.map(key => {
                                                        // key is size
                                                        return (
                                                            <tr key={key}>
                                                                {['name', 'photos', 'words', 'price']
                                                                    .map(key2 => {
                                                                        if (key2 === 'price')
                                                                            return (
                                                                                <td key={key2}>
                                                                                    ${this.props.school[key][key2]}
                                                                                </td>
                                                                            );
                                                                        return (
                                                                            <td key={key2}>
                                                                                {this.props.school[key][key2]}
                                                                            </td>
                                                                        );
                                                                    })
                                                                }
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </Table>
                                            ) : (<div/>)
                                        }

                                        {this.props.school.latefees !== undefined
                                            ? (
                                                <Table striped>
                                                    <thead>
                                                    <tr>
                                                        {
                                                            ['Date', 'Late Fee', 'Active?']
                                                                .map((prop, key) => {
                                                                    return (
                                                                        <th key={key}>{prop}</th>
                                                                    );
                                                                })
                                                        }
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.school.latefees.map(feeData => {
                                                        return (
                                                            <tr key={feeData.date}>
                                                                <td>
                                                                    <Moment unix
                                                                            tz={this.props.school.timezone}
                                                                            format="MMM D YYYY, h:mma">
                                                                        {feeData.date}
                                                                    </Moment>
                                                                </td>
                                                                <td>
                                                                    ${feeData.fee}
                                                                </td>
                                                                <td>
                                                                    {(moment.now()) > feeData.date
                                                                        ? 'ACTIVE'
                                                                        : ''
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                    </tbody>
                                                </Table>
                                            ) : (<div/>)
                                        }
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <Card
                                statsIcon="fa fa-history"
                                id="chartHours"
                                title="Submission History"
                                category="Your timeline of received, paid submissions"
                                stats="Up-to-date"
                                content={
                                    <div className="ct-chart">
                                        <ChartistGraph
                                            data={this.props.dateChart}
                                            type="Line"
                                            options={this.state.optionsSales}
                                            responsiveOptions={responsiveSales}
                                        />
                                    </div>
                                }
                                // legend={
                                //     <div className="legend">
                                //         {this.createLegend(
                                //             names:
                                //         )}
                                //     </div>
                                // }
                            />
                        </Col>
                    </Row>

                    {/*<Row>*/}
                    {/*<Col md={6}>*/}
                    {/*<Card*/}
                    {/*id="chartActivity"*/}
                    {/*title="2014 Sales"*/}
                    {/*category="All products including Taxes"*/}
                    {/*stats="Data information certified"*/}
                    {/*statsIcon="fa fa-check"*/}
                    {/*content={*/}
                    {/*<div className="ct-chart">*/}
                    {/*<ChartistGraph*/}
                    {/*data={dataBar}*/}
                    {/*type="Bar"*/}
                    {/*options={optionsBar}*/}
                    {/*responsiveOptions={responsiveBar}*/}
                    {/*/>*/}
                    {/*</div>*/}
                    {/*}*/}
                    {/*legend={*/}
                    {/*<div className="legend">*/}
                    {/*{this.createLegend(legendBar)}*/}
                    {/*</div>*/}
                    {/*}*/}
                    {/*/>*/}
                    {/*</Col>*/}

                    {/*<Col md={6}>*/}
                    {/*<Card*/}
                    {/*title="Tasks"*/}
                    {/*category="Backend development"*/}
                    {/*stats="Updated 3 minutes ago"*/}
                    {/*statsIcon="fa fa-history"*/}
                    {/*content={*/}
                    {/*<div className="table-full-width">*/}
                    {/*<table className="table">*/}
                    {/*<Tasks/>*/}
                    {/*</table>*/}
                    {/*</div>*/}
                    {/*}*/}
                    {/*/>*/}
                    {/*</Col>*/}
                    {/*</Row>*/}

                </Grid>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx